import apiRoutes from './api.routes';
import api from './api.service';
import ModelService from './model.service';

const UserService = new ModelService(apiRoutes.users, '/users', 'users');

UserService.createInvite = async model => api.catchError(async () => {
  const { data } = await api.post(apiRoutes.createInvite, model);
  return data;
});

UserService.defaultAvatar = `${api.baseUrl}/default-avatar.jpg`;

UserService.getAvatar = (filename, w = false, h = false, c = false) => {
  if (!filename) return UserService.defaultAvatar;
  return UserService.getFilePathByDir('/uploads/users', filename, w, h, c);
};

UserService.STATUS_ACTIVE = 1;
UserService.STATUS_INACTIVE = 0;
UserService.STATUS_UNDER_REVIEW = 2;
UserService.STATUS_PENDING = 3;

UserService.getStatusList = t => ({
  [UserService.STATUS_ACTIVE]: t('Active'),
  [UserService.STATUS_INACTIVE]: t('Inactive'),
  [UserService.STATUS_UNDER_REVIEW]: t('Under review'),
  [UserService.STATUS_PENDING]: t('Pending'),
});

UserService.getStatusOptions = t => UserService
  .prepareOptionsFromSimpleObject(UserService.getStatusList(t));

UserService.getStatusTitle = (status, t) => {
  const label = UserService.getStatusList(t)[status];
  return label || '-';
};

UserService.getColorByStatus = (status) => {
  switch (status) {
    case UserService.STATUS_ACTIVE:
      return 'success';
    case UserService.STATUS_INACTIVE:
      return 'danger';
    case UserService.STATUS_UNDER_REVIEW:
      return 'warning';
    case UserService.PENDING:
      return 'warning';
    default:
      return 'secondary';
  }
};

/** Types */
UserService.TYPE_SUBSCRIBER = 1;
UserService.TYPE_ADMIN = 2;
UserService.TYPE_USER = 3;

UserService.getTypeList = t => ({
  [UserService.TYPE_SUBSCRIBER]: t('Owner'),
  [UserService.TYPE_ADMIN]: t('Admin'),
  [UserService.TYPE_USER]: t('User'),
});

UserService.getTypeOptions = t => UserService
  .prepareOptionsFromSimpleObject(UserService.getTypeList(t));

UserService.getTypeTitle = (status, t) => {
  const label = UserService.getTypeList(t)[status];
  return label || '-';
};

UserService.getColorByType = (type) => {
  switch (type) {
    case UserService.TYPE_SUBSCRIBER:
      return 'success';
    case UserService.TYPE_ADMIN:
      return 'info';
    case UserService.TYPE_USER:
      return 'warning';
    default:
      return 'secondary';
  }
};

export default UserService;



// WEBPACK FOOTER //
// ./src/services/user.service.js